import { Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import claimBtnImg from "@assets/web-v3-images/free-bid-btn-bg.png";
import bgShweHours from "@assets/web-v3-images/shwe-hour-popup-bg.png";
import iconFreeBid from "@assets/web-v3-images/free-bid-icon.png";
import iconCoin from "@assets/images/shwe-hour-coin.png";
import iconSuperCoin from "@assets/images/shwe-hour-super-coin.png";
import iconPuzzlePiece from "@assets/images/shwe-hour-puzzle.png";
import Popups from "./popups";

// Ảnh minh hoạ theo loại thưởng ngẫu nhiên mà backend trả về (cùng bộ type với
// PopupShweHours bản cũ: reward.reward_type / shweHoursReward.type).
const REWARD_IMAGES = {
  FREE_TURN: iconFreeBid,
  NORMAL_COIN: iconCoin,
  SUPER_COIN: iconSuperCoin,
  PUZZLE_PIECE: iconPuzzlePiece,
};

/**
 * Popup "Shwe Hours Reward": báo người dùng đã đủ 10 lượt đoán giá trong giờ vàng
 * (19:00–21:00 MMT) và đã được nhận thưởng.
 *
 * Dựng theo cùng khuôn với ModalBidFree — ảnh nền đã gồm tia sáng, ruy băng và
 * tiêu đề "Shwe Hours Reward" nên chỉ cần phủ nội dung lên trên theo tỉ lệ ảnh
 * (880x1528): khung kem bên trong nằm trong khoảng 14.1%..89.1% ngang và
 * 26.4%..88.4% dọc (khung lệch nhẹ sang phải vì đuôi ruy băng bên trái dài hơn,
 * nên inset hai bên không bằng nhau).
 *
 * @param rewardType một trong REWARD_IMAGES; sai/thiếu thì bỏ trống ô ảnh.
 * @param pieceImage ảnh mảnh ghép do API trả về (reward.piece_image), chỉ dùng
 *        cho PUZZLE_PIECE vì mỗi mảnh là một hình khác nhau.
 */
export default function ModalShweHoursReward({
  open = true,
  onClose = () => {},
  rewardType,
  pieceImage,
}) {
  const { t } = useTranslation();

  const handleOpenChange = (nextOpen) => {
    if (!nextOpen) onClose();
  };

  const rewardImage =
    rewardType === "PUZZLE_PIECE"
      ? pieceImage || iconPuzzlePiece
      : REWARD_IMAGES[rewardType];

  return (
    <Popups
      open={open}
      onOpenChange={handleOpenChange}
      className="!bg-transparent !shadow-none !p-0 mx-auto"
    >
      {/* Chặn CHIỀU CAO của ảnh nền (ảnh là replaced element nên max-height tự co
          bề rộng đúng tỉ lệ) + wrapper w-fit ôm sát ảnh, để các lớp phủ định vị
          theo % vẫn khớp và vùng scroll của Radix không bao giờ bị tràn. */}
      <div className="relative mx-auto w-fit max-w-full">
        <img
          src={bgShweHours}
          alt=""
          className="block h-auto w-auto max-h-[100vh] max-w-full"
        />

        <div className="absolute top-[33%] bottom-[16%] left-[18%] right-[15%] flex flex-col items-center justify-between text-center">
          <Text
            as="p"
            className="text-[#854A0E] font-semibold leading-snug
              text-[13px] sm:text-[16px] md:text-[17px]"
          >
            {`${t("shwe_hour.popup.congrats")} ${t("shwe_hour.popup.this_is_10th")}`}
          </Text>

          {/* Ảnh thưởng co lại trước khi text bị bóp khi màn hình thấp.
              `animate-pop` là keyframe dùng chung sẵn có (0.55 -> 1.18 -> 1 với
              easing overshoot): phóng to vọt qua cỡ thật rồi dội về, chạy MỘT
              lần lúc popup mở. Gốc scale để mặc định ở tâm cho ảnh nở đều ra. */}
          <div className="flex min-h-0 flex-1 items-center justify-center py-[3%]">
            {rewardImage ? (
              <img
                src={rewardImage}
                alt=""
                className="max-h-full w-[80%] object-contain animate-pop motion-reduce:animate-none"
              />
            ) : null}
          </div>

          <Text
            as="p"
            className="text-[#854A0E] font-bold leading-snug
              text-[12px] sm:text-[13px] md:text-[14px]"
          >
            {`${t("shwe_hour.popup.footer_1")} ${t("shwe_hour.popup.footer_2")}`}
          </Text>

          {/* Nút: ảnh nền 474x96 đã đúng tỉ lệ design nên để ảnh tự co theo bề
              rộng, chữ phủ lên giữa. */}
          <button
            type="button"
            onClick={onClose}
            className="btn-click-active relative mt-[4%] w-[80%] shrink-0 cursor-pointer outline-none"
          >
            <img src={claimBtnImg} alt="" className="block h-auto w-full" />
            <Text
              as="span"
              className="absolute inset-0 flex select-none items-center justify-center
                font-semibold text-white
                text-[16px] sm:text-[22px] md:text-[24px]"
            >
              {t("shwe_hour.popup.got_it")}
            </Text>
          </button>
        </div>
      </div>
    </Popups>
  );
}
